/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */
// eslint-disable-next-line import/order
import type { ComponentType } from 'react';
import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import ContextualSurvey from '../contextual-survey-with-transition';

const ContextualSurveyWithEvents: ComponentType<any> = withEvents(ContextualSurvey);

export { ContextualSurvey, ContextualSurveyWithEvents };

// eslint-disable-next-line camelcase
const _default_1: ComponentType<any> = withMessage(ContextualSurveyWithEvents, 'contextualSurvey');
// eslint-disable-next-line camelcase
export default _default_1;
